import React, { Component } from 'react'

class Stats extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = { visible: false };
  }

  componentDidMount() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ visible: true });
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (this.ref.current) observer.observe(this.ref.current);
  }

  render() {
    return (
      <section className="vt-section dark tight">
        <div className="vt-shell">
          <div ref={this.ref} className={`vt-trust-grid${this.state.visible ? ' in' : ''}`}>
            <div className="vt-stat acc-mint" style={{ '--d': '0ms' }}>
              <div className="ic"><i data-lucide="timer"></i></div>
              <div className="v">5<span className="unit">min</span></div>
              <div className="tick"></div>
              <div className="l">la ration moyenne</div>
            </div>
            <div className="vt-stat acc-sky" style={{ '--d': '120ms' }}>
              <div className="ic"><i data-lucide="euro"></i></div>
              <div className="v">12<span className="unit">€/mois</span></div>
              <div className="tick"></div>
              <div className="l">tout compris, sans surprise</div>
            </div>
            <div className="vt-stat acc-peach" style={{ '--d': '240ms' }}>
              <div className="ic"><i data-lucide="microscope"></i></div>
              <div className="v">100<span className="unit">%</span></div>
              <div className="tick"></div>
              <div className="l">vétérinaire &amp; indépendant</div>
            </div>
            <div className="vt-stat acc-mint" style={{ '--d': '360ms' }}>
              <div className="ic"><i data-lucide="graduation-cap"></i></div>
              <div className="v">0<span className="unit">€</span></div>
              <div className="tick"></div>
              <div className="l">pour les étudiant·es</div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Stats;
